import React from 'react';
import cx from 'classnames';
import ClassProgressCellGroup from './ClassProgressCellGroup';
import ClassProgressStudentName from './ClassProgressStudentName';
import ThreadOverviewCell from './ThreadOverviewCell';

function ClassProgressRow(props) {
  const {studentData, rowNum, isBenchmarkOnly, isThreadOverview} = props;

  const hasPageBreak = rowNum !== 0 && rowNum % 22 === 0;
  const classProgressRowStyles = cx({
    "classProgressRow": true,
    "classProgressRowBreak": hasPageBreak,
  });

  const getCellGroups = () => {
    if (isThreadOverview) {
      const {
        phonologicalAwarenessPR,
        decodingPR,
        wordRecognitionPR,
        vocabularyPR,
        comprehensionPR,
        armPR,
        wcpmPR,
      } = studentData;
      return (
        <div className="classProgressCellContainer">
          <div className="classProgressCellGroup">
            <ThreadOverviewCell PR={phonologicalAwarenessPR} />
            <ThreadOverviewCell PR={decodingPR} />
            <ThreadOverviewCell PR={wordRecognitionPR} />
          </div>
          <div className="classProgressCellGroup">
            <ThreadOverviewCell PR={vocabularyPR} />
            <ThreadOverviewCell PR={comprehensionPR} />
          </div>
          <div className="classProgressCellGroup">
            <ThreadOverviewCell PR={wcpmPR} />
            <ThreadOverviewCell PR={armPR} />
          </div>
        </div>
      )
    }

    const {BOY={}, MOY={}, EOY={}, EM=null} = studentData;
    return (
      <div className="classProgressCellContainer">
        <ClassProgressCellGroup season={BOY} isBenchmarkOnly={isBenchmarkOnly} />
        <ClassProgressCellGroup season={MOY} isBenchmarkOnly={isBenchmarkOnly} />
        <ClassProgressCellGroup season={EOY} isBenchmarkOnly={isBenchmarkOnly} />
        {EM && <ClassProgressCellGroup season={EM} isBenchmarkOnly />}
      </div>
    );
  }

  return (
    <div className={classProgressRowStyles}>
      <ClassProgressStudentName studentData={studentData} />
      {getCellGroups()}
    </div>
  );
}

export default React.memo(ClassProgressRow);